import type { MapaCargoSecao } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const REDATOR_SECOES_A: MapaCargoSecao[] = 
[
  {
    id: 'adaptacao-de-textos-para-diferentes-plataformas',
    titulo: 'Adaptação de textos para diferentes plataformas',
    atividades: [
      'Ajustar o tom e o estilo dos textos para atender às especificidades de cada canal digital (ex.. Instagram, LinkedIn, Twitter, e-mail marketing).',
      'Criar conteúdos otimizados para redes sociais, com uso estratégico de textos.',
    ],
  },
  {
    id: 'revisao-e-edicao',
    titulo: 'Revisão e edição',
    atividades: [
      'Revisar textos para garantir qualidade gramatical, coesão e adequação ao briefing.',
      'Editar e refinar conteúdos para atender aos objetivos estratégicos da campanha.',
    ],
  },
  {
    id: 'criacao-de-conteudos-educativos',
    titulo: 'Criação de conteúdos educativos',
    atividades: [
      'Redigir conteúdos voltados para a nutrição de leads em automação de marketing.',
    ],
  },
  {
    id: 'elaboracao-de-textos-para-storytelling',
    titulo: 'Elaboração de textos para storytelling',
    atividades: [
      'Criar narrativas envolventes para conectar a marca ao público-alvo de maneira emocional.',
      'Desenvolver histórias que reforcem o posicionamento e os valores da marca.',
    ],
  },
  {
    id: 'criacao-de-legendas-e-textos-curtos',
    titulo: 'Criação de legendas e textos curtos',
    atividades: [
      'Desenvolver legendas para redes sociais que sejam impactantes e engajem os usuários.',
    ],
  },
  {
    id: 'producao-de-conteudo-tecnico-ou-especializado',
    titulo: 'Produção de conteúdo técnico ou especializado',
    atividades: [
      'Escrever textos que demandam maior profundidade técnica ou pesquisa detalhada, como em nichos B2B ou áreas como saúde, tecnologia e finanças.',
    ],
  },
  {
    id: 'gestao-de-cronogramas-e-prazos',
    titulo: 'Gestão de cronogramas e prazos',
    atividades: [
      'Organizar entregas de acordo com os cronogramas das campanhas ou calendários desenvolvidos.',
      'Gerenciar fluxos de trabalho com diferentes clientes e demandas.',
    ],
  },
  {
    id: 'participacao-em-estrategias-de-branding',
    titulo: 'Participação em estratégias de branding',
    atividades: [
      'Contribuir na definição de tom de voz e identidade textual da marca.',
      'Garantir que todos os textos refletem a personalidade e os valores da marca.',
    ],
  },
  {
    id: 'criacao-de-scripts-para-videos',
    titulo: 'Criação de scripts para vídeos',
    atividades: [
      'Redigir roteiros detalhados para vídeos institucionais, tutoriais etc.',
      'Estruturar conteúdos que mantenham a atenção do público.',
    ],
  },
  {
    id: 'testes-a-b-e-otimizacoes',
    titulo: 'Testes A/B e otimizações',
    atividades: [
      'Ajustar textos com base nos resultados das métricas.',
      'Gestão de plataformas',
      'Dominar e gerenciar diferentes plataformas de mídia e redes sociais, como Facebook, Instagram, TikTok, Pinterest, entre outros, com o objetivo de garantir a correta veiculação dos conteúdos, bem como a performance adequada de acordo com as melhores práticas',
    ],
  },
  {
    id: 'pesquisa-e-analise-de-tendencias',
    titulo: 'Pesquisa e análise de tendências',
    atividades: [
      'Monitorar as tendências de mercado e comportamento do consumidor para criar conteúdos atualizados e relevantes.',
      'Analisar o desempenho de conteúdos anteriores para aprimorar estratégias futuras.',
    ],
  },
  {
    id: 'criacao-de-conteudos-para-personas-especificas',
    titulo: 'Criação de conteúdos para personas específicas',
    atividades: [
      'Desenvolver textos direcionados para diferentes segmentos de público dentro do mesmo nicho.',
      'Personalizar mensagens para gerar maior impacto.',
    ],
  },
  {
    id: 'elaboracao-de-propostas-e-apresentacoes',
    titulo: 'Elaboração de propostas e apresentações',
    atividades: [
      'Auxiliar na criação de apresentações persuasivas para propostas de campanhas e projetos.',
      'Redigir textos que facilitem o entendimento e venda das ideias aos clientes.',
    ],
  },
  {
    id: 'atendimento-ao-cliente',
    titulo: 'Atendimento ao cliente',
    atividades: [
      'Servir de ponto de contato entre clientes e a equipe da agência.',
      'Reunir feedbacks e acompanhar aprovações e revisões.',
      'Coordenador Mkt',
      'Coordenador',
    ],
  },
  {
    id: 'planejamento-estrategico',
    titulo: 'Planejamento estratégico',
    atividades: [
      'Desenvolver planos de ação alinhados aos objetivos da empresa.',
      'Identificar prioridades e ajustar estratégias para atender demandas.',
    ],
  },
  {
    id: 'gestao-de-processos-e-melhorias',
    titulo: 'Gestão de processos e melhorias',
    atividades: [
      'Mapear, documentar e otimizar processos internos para aumentar a eficiência.',
      'Identificar gargalos e propor soluções para melhorar o fluxo de trabalho.',
    ],
  },
  {
    id: 'monitoramento-e-avaliacao-de-desempenho',
    titulo: 'Monitoramento e avaliação de desempenho',
    atividades: [
      'Acompanhar o progresso das atividades e avaliar o desempenho da equipe.',
      'Implementar KPIs (Indicadores-Chave de Desempenho) para medir resultados.',
    ],
  },
  {
    id: 'mediacao-de-conflitos',
    titulo: 'Mediação de conflitos',
    atividades: [
      'Resolver problemas entre membros da equipe ou com partes externas, garantindo a harmonia no ambiente de trabalho.',
      'Manter um canal aberto de comunicação para prevenir e lidar com conflitos.',
    ],
  },
]
